// Utility classes for the checklist rows (ul.checklist). The check mark (label:after) and the
// `li.selected` row stay in app/css/checklist.css.
export const CHECKLIST = "tw:mt-[10px]";
export const CHECKLIST_ITEM =
  "tw:flex tw:w-full tw:cursor-pointer tw:flex-row tw:items-center tw:pt-[3px] tw:pb-[3px] tw:[&:hover]:bg-[#eee]";
export const CHECKLIST_BOX_WRAPPER = "tw:mr-[6px] tw:h-[20px] tw:w-[20px]";
export const CHECKLIST_BOX =
  "tw:relative tw:inline-block tw:h-[20px] tw:w-[20px] tw:[background:linear-gradient(to_bottom,#d5d5d5_0%,#c5c5c5_40%,#b5b5b5_100%)] tw:[li:hover_&]:[background:linear-gradient(to_bottom,#a5a5a5_0%,#959595_40%,#858585_100%)]";
export const CHECKLIST_BOX_INPUT = "tw:invisible";
export const CHECKLIST_BOX_LABEL =
  "tw:absolute tw:top-[2px] tw:left-[2px] tw:h-[16px] tw:w-[16px] tw:cursor-pointer tw:bg-[#fff]";
export const CHECKLIST_LABEL = "tw:relative tw:inline-block tw:grow";

// The "n of m selected" row above a checklist.
export const LIST_STATUS =
  "tw:flex tw:justify-between tw:[margin:10px_0px_0px_0px]";
export const LIST_SELECT_STATUS = "tw:opacity-[0.75]";
export const LIST_SHARE = "tw:text-right";
export const LIST_SHARE_LINK =
  "tw:no-underline tw:[.list-status_.list-share_&:hover]:[text-decoration:underline]";

/** Joins class names, skipping empty ones. */
export function cx(...names: (string | false | undefined)[]): string {
  return names.filter(Boolean).join(" ");
}
